import * as style from './style.css';
import NorthCircleIcon from '../../assets/icons/NorthCircleIcon';
import React = require('react');

interface IProps{
}

interface IState{}

export default class ScrollUpButton extends React.Component<IProps, IState> {
    render() {
        return (
            <a id={'scrollUpButton'} className={style.scrollUp} href="#">
                <NorthCircleIcon fontSize={'2rem'}/>
            </a>
        );
    }
}
